@if (!companyFailedToLoad && !userIdFailedToLoad) {
  <h1 class="content-main-title">{{ createWhat }}</h1>
  <div class="d-flex justify-content-end">{{ 'content.all.required-field-explanation' | translate }}</div>
  <form #form [formGroup]="f" [ngClass]="{'form-submitted': formSubmitted}" (ngSubmit)="submit(f.value)">
    <h2>{{ 'content.user' | translate }}</h2>
    <div class="row">
      <div class="form-group col-md-4 pe-2">
        <label for="firstName">{{ 'content.person.first-name' | translate }} *
          <input #firstNameInput id="firstName" class="form-control" type="text" autocomplete="on" formControlName="firstName">
        </label>
        <app-validation-errors [displayErrors]="formSubmitted" [element]="firstNameInput" [errors]="c.firstName.errors"></app-validation-errors>
      </div>
      <div class="form-group col-md-4 pe-2">
        <label for="middleName">{{ 'content.person.middle-name' | translate }}
          <input #middleNameInput id="middleName" class="form-control" type="text" autocomplete="on" formControlName="middleName">
        </label>
        <app-validation-errors [displayErrors]="formSubmitted" [element]="middleNameInput" [errors]="c.middleName.errors"></app-validation-errors>
      </div>
      <div class="form-group col-md-4">
        <label for="lastName">{{ 'content.person.last-name' | translate }} *
          <input #lastNameInput id="lastName" class="form-control" type="text" autocomplete="on" formControlName="lastName">
        </label>
        <app-validation-errors [displayErrors]="formSubmitted" [element]="lastNameInput" [errors]="c.lastName.errors"></app-validation-errors>
      </div>
    </div>
    <div class="form-group">
      <label for="inputEmail1">{{ 'content.person.email' | translate }} *
        <input #emailInput
          id="inputEmail1"
          class="form-control"
          type="email"
          autocomplete="on"
          formControlName="email"
          placeholder="email@example.com" (ngModelChange)="c.confirmEmail.updateValueAndValidity()">
        </label>
        <app-validation-errors [displayErrors]="formSubmitted" [element]="emailInput" [errors]="c.email.errors"></app-validation-errors>
      </div>
      <div class="form-group">
        <label for="inputEmail2">{{ 'content.confirm-email' | translate }} *
          <input #confirmEmailInput id="inputEmail2" class="form-control" type="email" autocomplete="on" formControlName="confirmEmail" placeholder="email@example.com">
        </label>
        <app-validation-errors [displayErrors]="formSubmitted" [element]="confirmEmailInput" [errors]="c.confirmEmail.errors"></app-validation-errors>
      </div>
      <app-phone-form-row extensionFormControlName="extension"
        phoneFormControlName="phone"
        phoneNumberCssClass="col-md-4"
        [displayErrors]="formSubmitted"
      [formGroup]="f"></app-phone-form-row>
      <div class="row">
        <fieldset class="form-group form-inline row col-md-12" aria-labelledby="language-preference-label">
          <legend id="language-preference-label" class="col-md-3">{{ 'content.language-preference' | translate }} *</legend>
          <div class="row ps-0 pe-0 pt-1">
            <div class="form-inline ps-0">
              <input id="language-english" class="form-check-input" type="radio" formControlName="languagePreference" name="languagePreference" value="EN">
              <label class="form-check-label ps-0" for="language-english">{{ 'content.english' | translate }}</label>
              <input id="language-french" class="form-check-input ms-3" type="radio" formControlName="languagePreference" name="languagePreference" value="FR">
              <label class="form-check-label ps-0" for="language-french">{{ 'content.french' | translate }}</label>
            </div>
          </div>
        </fieldset>
      </div>
      @if (!isForSpecificCompany) {
        <div>
          <fieldset class="form-group form-inline form-row col-md-12" aria-labelledby="user-type-label">
            <legend id="user-type-label">{{ 'content.user-type' | translate }}</legend>
            <div class="row ps-0 pe-0 pt-1">
              <div class="form-inline ps-0">
                <input id="user-type-input" class="form-check-input" type="radio" formControlName="companyUserType" name="companyUserType" value="user">
                <label for="user-type-input" class="form-check-label ps-0">{{ 'content.user' | translate }}</label>
                <input id="admin-type-input" class="form-check-input ms-3" type="radio" formControlName="companyUserType" name="companyUserType" value="admin">
                <label for="admin-type-input" class="form-check-label ps-0">{{ 'content.admin-title' | translate }}</label>
              </div>
            </div>
          </fieldset>
          <h2>{{ 'content.company' | translate }}</h2>
          <p>{{ 'content.load-branches-explanation' | translate }}</p>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label>{{ 'content.company' | translate }} *
                <input class="form-control" type="text" autocomplete="on" formControlName="company" placeholder="{{ 'content.company' | translate }}"
                  (keydown.enter)="$event.preventDefault(); manuallyTypedCompanyName()">
                </label>
                @if (!manualCompanyFound) {
                  <div class="invalid-feedback">{{ 'content.does-not-exist' | translate }}</div>
                }
                <button class="tu-button primary tu-shadow mt-2" type="button" (click)="manuallyTypedCompanyName()">{{ 'content.load-branches' | translate }}</button>
              </div>
            </div>
          </div>
        }
        @if (branchNames && branchNames.length > 0) {
          <div>
            <h2>{{ 'content.branches' | translate }}</h2>
            <div class="form-row">
              <fieldset #branchNameInput>
                <legend class="assign-branches">{{ 'content.assign-member-codes' | translate }} {{ (companyUserType | async) === 'user' ? '*' : '' }}</legend>
                <div class="d-flex flex-wrap" [formGroup]="memberCodesFormGroup">
                  @for (branchName of branchNames; track branchName) {
                    <label class="form-check-label col-12 col-sm-6 col-lg-4">
                      <input class="form-check-input" type="checkbox" [formControlName]="branchName">
                      {{ branchName }}
                    </label>
                  }
                </div>
              </fieldset>
              <app-validation-errors
                [ariaConfig]="{required: false}" [displayErrors]="formSubmitted" [element]="branchNameInput" [errors]="memberCodesFormGroup.errors">
              </app-validation-errors>
            </div>
          </div>
        }
        <h2>{{ 'content.security' | translate }}</h2>
        <h3>{{ 'content.access-times' | translate }}</h3>
        <app-access-times [createUserFormGroup]="createUserFormGroup" [userFormSubmitted$]="formSubmitted$"></app-access-times>
        <h3 id="ip-restriction-label">{{ 'content.ip-address-restriction' | translate }}</h3>
        <div class="row form-inline" aria-labelledby="ip-restriction-label" role="group" [formGroup]="ipRestrictionsFormGroup">
          @for (v of (ipRestrictionsControlsMap | keyvalue); track v; let i = $index) {
            <div class="form-group col-12">
              <div class="row mb-3 justify-content-start" [formGroup]="ipRestrictionFormGroup(v.key)">
                <label for="ip-address-1" class="col-sm-auto col-form-label">{{ 'content.start-ip' | translate }}:
                  <app-required [control]="ipRestrictionFormGroup(v.key).controls.startIp"></app-required>
                </label>
                <div class="col-sm-auto ms-2 me-2">
                  <input #ipInput1 id="ip-address-1" class="form-control" type="text" autocomplete="on" formControlName="startIp"
                    mask="IP" placeholder="111.111.111.111" [dropSpecialCharacters]="false" [validation]="false">
                    <app-validation-errors [displayErrors]="formSubmitted" [element]="ipInput1" [errors]="ipRestrictionFormGroup(v.key).controls.startIp.errors"></app-validation-errors>
                  </div>
                  <label for="ip-address-2" class="col-sm-auto col-form-label">{{ 'content.end-ip' | translate }}:
                    <app-required [control]="ipRestrictionFormGroup(v.key).controls.endIp"></app-required>
                  </label>
                  <div class="col-sm-2 ms-2 me-2">
                    <input #ipInput2 id="ip-address-2" class="form-control" type="text" autocomplete="on" formControlName="endIp"
                      mask="IP" placeholder="111.111.111.112" [dropSpecialCharacters]="false" [validation]="false">
                      <app-validation-errors [displayErrors]="formSubmitted" [element]="ipInput2" [errors]="ipRestrictionFormGroup(v.key).controls.endIp.errors"></app-validation-errors>
                    </div>
                    <div class="col-sm-auto">
                      @if (ipRestrictionsLength > 1) {
                        <button
                          class="tu-button secondary tu-shadow ms-2"
                          type="button"
                        (click)="removeIp(v.key)">{{ 'content.remove-ip' | translate }}</button>
                      }
                    </div>
                    <div class="col-sm-auto">
                      @if (i === ipRestrictionsCount() - 1) {
                        <button
                          class="tu-button primary tu-shadow ms-2"
                          type="button"
                        (click)="insertIp()">{{ 'content.insert-ip' | translate }}</button>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
            <div class="d-flex inline-gap-5 submit-buttons justify-content-end">
              <button class="tu-button secondary tu-shadow" type="button" (click)="cancel()">{{ 'content.cancel' | translate }}</button>
              <button class="tu-button primary tu-shadow" type="submit">{{ 'content.save' | translate }}</button>
            </div>
          </form>
        }
        @if (companyFailedToLoad) {
          <div>
            {{ 'content.company-not-found' | translate:{companyName: companyNameParam} }}
          </div>
        }
        @if (userIdFailedToLoad) {
          <div>
            {{ 'content.item-not-found' | translate:{item: userIdParam} }}
          </div>
        }
